import { defineComponent as C, h as S, ref as M, provide as I } from "vue";
import { formInjectionKey as O, formItemInstsInjectionKey as P } from "./highrise1051.mjs";
import _ from "./highrise1052.mjs";
import k from "./highrise1053.mjs";
import x from "./highrise984.mjs";
import B from "./highrise1019.mjs";
import { keysOf as w } from "./highrise1054.mjs";
var F = function(t, c, o, i) {
  function h(s) {
    return s instanceof o ? s : new o(function(a) {
      a(s);
    });
  }
  return new (o || (o = Promise))(function(s, a) {
    function v(n) {
      try {
        e(i.next(n));
      } catch (l) {
        a(l);
      }
    }
    function f(n) {
      try {
        e(i.throw(n));
      } catch (l) {
        a(l);
      }
    }
    function e(n) {
      n.done ? s(n.value) : h(n.value).then(v, f);
    }
    e((i = i.apply(t, c || [])).next());
  });
};
const L = Object.assign(Object.assign({}, x.props), {
  inline: Boolean,
  labelWidth: [Number, String],
  labelAlign: String,
  labelPlacement: {
    type: String,
    default: "top"
  },
  model: {
    type: Object,
    default: () => {
    }
  },
  rules: Object,
  disabled: Boolean,
  size: String,
  showRequireMark: {
    type: Boolean,
    default: void 0
  },
  requireMarkPlacement: String,
  showFeedback: {
    type: Boolean,
    default: !0
  },
  onSubmit: {
    type: Function,
    default: (t) => {
      t.preventDefault();
    }
  },
  showLabel: {
    type: Boolean,
    default: void 0
  },
  validateMessages: Object
}), N = C({
  name: "Form",
  props: L,
  setup(t) {
    const {
      mergedClsPrefixRef: c
    } = k(t);
    x("Form", "-form", _, B, t, c);
    const o = {}, i = M(void 0), h = (f) => {
      const e = i.value;
      (e === void 0 || f >= e) && (i.value = f);
    };
    function s(f) {
      return F(this, arguments, void 0, function* (e, n = () => !0) {
        return yield new Promise((l, j) => {
          const y = [];
          for (const u of w(o)) {
            const p = o[u];
            for (const r of p)
              r.path && y.push(r.internalValidate(null, n));
          }
          Promise.all(y).then((u) => {
            const p = u.some((d) => !d.valid), r = [], m = [];
            u.forEach((d) => {
              var g, b;
              !((g = d.errors) === null || g === void 0) && g.length && r.push(d.errors), !((b = d.warnings) === null || b === void 0) && b.length && m.push(d.warnings);
            }), e && e(r.length ? r : void 0, {
              warnings: m.length ? m : void 0
            }), p ? j(r.length ? r : void 0) : l({
              warnings: m.length ? m : void 0
            });
          });
        });
      });
    }
    function a() {
      for (const f of w(o)) {
        const e = o[f];
        for (const n of e)
          n.restoreValidation();
      }
    }
    return I(O, {
      props: t,
      maxChildLabelWidthRef: i,
      deriveMaxChildLabelWidth: h
    }), I(P, {
      formItems: o
    }), Object.assign({
      validate: s,
      restoreValidation: a
    }, {
      mergedClsPrefix: c
    });
  },
  render() {
    const {
      mergedClsPrefix: t
    } = this;
    return S("form", {
      class: [`${t}-form`, this.inline && `${t}-form--inline`],
      onSubmit: this.onSubmit
    }, this.$slots);
  }
});
export {
  N as default,
  L as formProps
};
